<template>

  <div class="rounded green lighten-4 pa-3">
  <v-row>
    <v-col
        cols="12"
        sm="3"
        md="3"
    >
      <v-text-field
          v-model="itemModified.halalJenisPembatasZona"
          label="Jenis Pembatas Zona Halal"
          dense
          hide-details
      ></v-text-field>
    </v-col>
    <v-col
        cols="12"
        sm="3"
        md="3"
    >
      <v-text-field
          v-model="itemModified.halalLogistik"
          label="Logistik yang Digunakan"
          dense
          hide-details
      ></v-text-field>
    </v-col>
    <v-col
        cols="12"
        sm="3"
        md="3"
    >
      <v-text-field
          v-model="itemModified.halalLabDanLph"
          label="Laboratorium dan LPH yang digunakan"
          dense
          hide-details
      ></v-text-field>
    </v-col>
    <v-col
        cols="12"
        sm="3"
        md="3"
    >
      <v-text-field
          v-model="itemModified.skemaPembayaran"
          label="Skema Pembayaran"
          dense
          hide-details
      ></v-text-field>
    </v-col>

  </v-row>

</div>

</template>

<script>
import FPotensi from "@/models/f-potensi";

export default {
  name: "FPotensiKawasanKriteriaKih",
  props:{
    kawasan: Boolean,
    itemModified: new FPotensi(),
    itemsFDivision: [],
  },
  data(){
    return{
      rulesLenght: [
        v => !!v || ' Tidak Boleh Kosong',
        v => v.length <= 255 || 'Maksimal 255 Karakter',
        v => v.length > 1 || 'Harus lebih besar dari 1 karakter'
      ],
      rulesNotEmtpy: [
        v => !!v || 'Tidak boleh kosong'
      ],

    }
  },
  computed:{
  },
  methods:{

    lookupFDivision (fdivisionBean) {
      // console.log(fdivisionBean)
      // console.log(JSON.stringify(this.itemsFDivision))
      const str = this.itemsFDivision.filter(x => x.id === fdivisionBean)

      if (str.length>0){
        return str[0]
      }else {
        return '-'
      }
    },

  }


}
</script>

<style scoped>

</style>